// src/config/consts/contact/social/index.ts
export const APP_SOCIAL_FACEBOOK = 'https://www.facebook.com/yewok.industrie';
export const APP_SOCIAL_TWITTER = 'https://x.com/Starcadia_io';
export const APP_SOCIAL_MEDIUM = 'https://medium.com/@starcadiaio';
export const APP_SOCIAL_INSTAGRAM = 'https://www.instagram.com/deagle.dev';
export const APP_SOCIAL_LINKEDIN = 'https://www.linkedin.com/in/yohan-anton-7139a2215/';
export const APP_SOCIAL_WHATSAPP = 'https://wa.me/33753903869';
export const APP_SOCIAL_TELEGRAM = 'https://t.me/StarcadiaPlay';
export const APP_SOCIAL_DISCORD = 'https://discord.com/invite/r4S76AtfzW';
export const APP_SOCIAL_YOUTUBE = 'https://www.youtube.com/@starcadiaplaytoearn7092';
export const APP_SOCIAL_LINE = 'https://line.me/ti/p/-h5Kn311JP';
export const APP_SOCIAL_REDDIT = 'https://www.reddit.com/user/Starcadiahub/';
export const APP_SOCIAL_SNAPCHAT = 'https://www.snapchat.com/add/sephyone?share_id=IDq9JZCY65M&locale=fr-FR';
export const APP_SOCIAL_TIKTOK = 'https://www.tiktok.com/@sashamars13';
